/* ============================================================
   Encirco PPF Partner Portal — ppf-portal.js
   Ported to Dawn theme with trade-approved price gating added:
   card prices, modal price, and the order button now check
   window.PPF_TRADE_APPROVED before showing real pricing or
   allowing checkout.

   The enquiry-form functions (submitContactForm, ppfSubmitCantFind,
   ppfSubmitBespoke) are defined at top level, not inside ppfInit(),
   so the "Can't Find Your Vehicle" and bespoke-film forms work on
   any page (e.g. the standalone Custom Quote page) even when the
   product grid/ppfInit never runs.
   ============================================================ */

// ── SHARED ENQUIRY FORM HELPERS (top-level: work on any page) ──
function submitContactForm(name, email, subject, message, successFieldsId, successMsgId) {
  document.getElementById('ppf-hidden-name').value    = name;
  document.getElementById('ppf-hidden-email').value   = email;
  document.getElementById('ppf-hidden-subject').value = subject;
  document.getElementById('ppf-hidden-body').value    = message;
  document.getElementById('ppf-hidden-submit').click();
  document.getElementById(successFieldsId).style.display = 'none';
  document.getElementById(successMsgId).style.display    = 'block';
}

window.ppfSubmitCantFind = function () {
  var first    = document.getElementById('ppf-cf-first');
  var last     = document.querySelector('#ppf-cf-fields .ppf-fr2:first-child .ppf-fg2:last-child input');
  var email    = document.getElementById('ppf-cf-email');
  var phone    = document.querySelector('#ppf-cf-fields .ppf-fr2:nth-child(2) .ppf-fg2:last-child input');
  var make     = document.getElementById('ppf-cf-make');
  var model    = document.getElementById('ppf-cf-model');
  var year     = document.getElementById('ppf-cf-year');
  var coverage = document.querySelector('#ppf-cf-fields .ppf-inline-select');
  var notes    = document.querySelector('#ppf-cf-fields textarea');

  if (!first.value.trim() || !email.value.trim() || !make.value.trim() || !model.value.trim() || !year.value.trim()) {
    alert('Please fill in all required fields.');
    return;
  }

  var message = [
    'PPF CUSTOM KIT REQUEST',
    '───────────────────────',
    'Name: ' + first.value.trim() + ' ' + (last ? last.value.trim() : ''),
    'Email: ' + email.value.trim(),
    'Phone: ' + (phone ? phone.value.trim() || 'Not provided' : 'Not provided'),
    '',
    'Vehicle Details',
    'Make: ' + make.value.trim(),
    'Model: ' + model.value.trim(),
    'Year: ' + year.value.trim(),
    'Coverage: ' + (coverage ? coverage.value : 'Not specified'),
    '',
    'Additional Notes:',
    (notes ? notes.value.trim() || 'None' : 'None')
  ].join('\n');

  submitContactForm(
    first.value.trim() + ' ' + (last ? last.value.trim() : ''),
    email.value.trim(),
    'PPF Enquiry — Custom Kit Request',
    message,
    'ppf-cf-fields',
    'ppf-cf-success'
  );
};

window.ppfSubmitBespoke = function () {
  var name    = document.getElementById('ppf-bs-name');
  var email   = document.getElementById('ppf-bs-email');
  var vehicle = document.getElementById('ppf-bs-vehicle');
  var film    = document.querySelector('#ppf-bs-fields .ppf-fr2:nth-child(2) .ppf-fg2:last-child input');
  var notes   = document.querySelector('#ppf-bs-fields textarea');

  if (!name.value.trim() || !email.value.trim() || !vehicle.value.trim()) {
    alert('Please fill in all required fields.');
    return;
  }

  var message = [
    'PPF BESPOKE FILM ENQUIRY',
    '─────────────────────────',
    'Name: ' + name.value.trim(),
    'Email: ' + email.value.trim(),
    '',
    'Vehicle: ' + vehicle.value.trim(),
    'Film Interested In: ' + (film ? film.value.trim() || 'Not specified' : 'Not specified'),
    '',
    'Requirements / Notes:',
    (notes ? notes.value.trim() || 'None' : 'None')
  ].join('\n');

  submitContactForm(
    name.value.trim(),
    email.value.trim(),
    'PPF Enquiry — Bespoke Film Request',
    message,
    'ppf-bs-fields',
    'ppf-bs-success'
  );
};

function ppfInit() {
  'use strict';

  var S       = window.PPF_SETTINGS || {};
  var TRADE_APPROVED = !!window.PPF_TRADE_APPROVED;
  var PRODUCTS_RAW = window.PPF_PRODUCTS || [];
  if (!PRODUCTS_RAW.length) return;

  var PRICES = S.prices || {
    shield: { partial: 582,    front: 762,    track: 892.2,   full: 1782 },
    lite:   { partial: 550.03, front: 708.71, track: 828.26,  full: 1638 },
    matt:   { partial: 658.67, front: 865.66, track: 1014.57, full: 1998 }
  };

  var DIAGRAMS = S.diagrams || {};

  var COVERAGE_MAP = {
    partial: 'Partial Front End',
    front:   'Front End',
    track:   'Track Pack',
    full:    'Full Coverage'
  };
  var BRAND_MAP = {
    shield: 'STEK DynoSheild -Gloss',
    lite:   'STEK DynoSheild -Gloss',
    matt:   'STEK DynoMatt -Matt'
  };

  var BATCH_SIZE = 12;

  // ── MODEL NAME INTELLIGENCE ──
  var MODEL_SERIES_MAP = {
    'BMW': {
      '1': '1 Series', '2': '2 Series', '3': '3 Series', '4': '4 Series',
      '5': '5 Series', '6': '6 Series', '7': '7 Series', '8': '8 Series',
      'i3': 'i3', 'i3s': 'i3s', 'i4': 'i4', 'i5': 'i5', 'i7': 'i7', 'i8': 'i8',
      'iX': 'iX', 'iX1': 'iX1', 'iX2': 'iX2', 'iX3': 'iX3',
      'M2': 'M2', 'M3': 'M3', 'M4': 'M4', 'M5': 'M5', 'M8': 'M8',
      'X1': 'X1', 'X2': 'X2', 'X3': 'X3', 'X4': 'X4', 'X5': 'X5',
      'X6': 'X6', 'X7': 'X7', 'XM': 'XM', 'Z4': 'Z4'
    },
    'Mercedes-Benz': {
      'A': 'A-Class', 'B': 'B-Class', 'C': 'C-Class', 'E': 'E-Class',
      'G': 'G-Class', 'S': 'S-Class', 'CLA': 'CLA', 'CLS': 'CLS',
      'GLA': 'GLA', 'GLB': 'GLB', 'GLC': 'GLC', 'GLE': 'GLE',
      'GLS': 'GLS', 'AMG': 'AMG GT', 'SL': 'SL', 'SLC': 'SLC'
    },
    'Audi': {
      'A1': 'A1', 'A3': 'A3', 'A4': 'A4', 'A5': 'A5', 'A6': 'A6',
      'A7': 'A7', 'A8': 'A8', 'Q2': 'Q2', 'Q3': 'Q3', 'Q4': 'Q4',
      'Q5': 'Q5', 'Q7': 'Q7', 'Q8': 'Q8', 'TT': 'TT', 'R8': 'R8',
      'RS3': 'RS3', 'RS4': 'RS4', 'RS5': 'RS5', 'RS6': 'RS6', 'RS7': 'RS7'
    },
    'Volkswagen': {
      'Polo': 'Polo', 'Golf': 'Golf', 'Passat': 'Passat', 'Tiguan': 'Tiguan',
      'T-Roc': 'T-Roc', 'T-Cross': 'T-Cross', 'Touareg': 'Touareg',
      'Arteon': 'Arteon', 'ID.3': 'ID.3', 'ID.4': 'ID.4'
    }
  };

  function friendlyModelName(make, rawModel) {
    if (!rawModel) return rawModel;
    var map = MODEL_SERIES_MAP[make];
    if (map && map[rawModel]) return map[rawModel];
    if (/^\d$/.test(rawModel)) return rawModel + ' Series';
    return rawModel;
  }

  // ── PARSE PRODUCTS ──
  var MULTI_MAKES = ['Aston Martin', 'Land Rover', 'Alfa Romeo', 'Rolls-Royce', 'Mercedes-Benz'];

  function parseTitle(raw) {
    var title = (raw || '').replace(/\s*PPF Kit\s*$/i, '').trim();

    var yearMatch = title.match(/\s+(\d{4}\s*[-\u2013]\s*(?:\d{4}|[Pp]resent))\s*$/);
    var year = '';
    if (yearMatch) {
      year = yearMatch[1].replace(/\s+/g, '').replace(/[Pp]resent/, 'Present');
      title = title.slice(0, yearMatch.index).trim();
    }

    var chassisMatch = title.match(/\s*\(([^)]+)\)\s*$/);
    var chassis = '';
    if (chassisMatch) {
      chassis = chassisMatch[1];
      title = title.slice(0, chassisMatch.index).trim();
    }

    var make = '';
    for (var mi = 0; mi < MULTI_MAKES.length; mi++) {
      if (title.toLowerCase().indexOf(MULTI_MAKES[mi].toLowerCase() + ' ') === 0) {
        make = MULTI_MAKES[mi]; break;
      }
    }
    if (!make) {
      make = title.split(' ')[0] || '';
      if (make === 'MW') make = 'BMW';
    }

    var rest = title.slice(make.length).trim();
    var restParts = rest.split(' ');
    var baseModel = restParts[0] || rest;
    var trimVariant = restParts.slice(1).join(' ');
    var displayModel = friendlyModelName(make, baseModel);

    return {
      make: make,
      model: baseModel,
      displayModel: displayModel,
      trim: trimVariant,
      chassis: chassis,
      year: year,
      fullModel: rest
    };
  }

  var PRODUCTS = PRODUCTS_RAW.map(function (p) {
    var parsed = parseTitle(p.title);
    return {
      title:        p.title,
      handle:       p.handle,
      image:        p.image || '',
      make:         parsed.make,
      model:        parsed.model,
      displayModel: parsed.displayModel,
      fullModel:    parsed.fullModel,
      trim:         parsed.trim,
      chassis:      parsed.chassis,
      year:         parsed.year
    };
  });

  // ── STATE ──
  var selBrandKey = 'shield';
  var selCovKey   = 'front';
  var currentHandle = '';
  var currentOffset = 0;
  var currentList = [];

  // ── UTILS ──
  function uniq(arr) {
    var seen = {};
    return arr.filter(function (v) {
      if (!v || seen[v]) return false;
      seen[v] = true; return true;
    }).sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
  }

  function filtered(m, mo, y) {
    return PRODUCTS.filter(function (p) {
      return (!m || p.make === m) && (!mo || p.model === mo) && (!y || p.year === y);
    });
  }

  function calcPrice() {
    var p = PRICES[selBrandKey] || {};
    return p[selCovKey] || 0;
  }

  // ── DOM REFS ──
  var selMake  = document.getElementById('ppf-sel-make');
  var selModel = document.getElementById('ppf-sel-model');
  var selYear  = document.getElementById('ppf-sel-year');
  var selTrim  = document.getElementById('ppf-sel-trim');
  var resetBtn = document.getElementById('ppf-reset-btn');
  var pgrid    = document.getElementById('ppf-pgrid');
  var nores    = document.getElementById('ppf-nores');
  var resCnt   = document.getElementById('ppf-res-count');
  var moverlay = document.getElementById('ppf-moverlay');

  if (!selMake) return;

  // ── POPULATE MAKES ──
  uniq(PRODUCTS.map(function (p) { return p.make; })).forEach(function (m) {
    var o = document.createElement('option');
    o.value = m; o.textContent = m;
    selMake.appendChild(o);
  });

  // ── CASCADE DROPDOWNS ──
  function updateModels() {
    var m = selMake.value;
    var rawMods = uniq(filtered(m, '', '').map(function (p) { return p.model; }));
    selModel.innerHTML = '<option value="">' + (m ? 'All Models' : 'Select make first') + '</option>';
    rawMods.forEach(function (rawMod) {
      var sample = PRODUCTS.find(function(p) { return (!m || p.make === m) && p.model === rawMod; });
      var display = sample ? sample.displayModel : rawMod;
      var o = document.createElement('option');
      o.value = rawMod;
      o.textContent = display;
      selModel.appendChild(o);
    });
    selModel.disabled = !m;
    selYear.disabled = true;
    selTrim.disabled = true;
    selYear.innerHTML  = '<option value="">Select model first</option>';
    selTrim.innerHTML  = '<option value="">Select year first</option>';
    render();
  }

  function updateYears() {
    var m = selMake.value, mo = selModel.value;
    var yrs = uniq(filtered(m, mo, '').map(function (p) { return p.year; }));
    selYear.innerHTML = '<option value="">' + (mo ? 'All Years' : 'Select model first') + '</option>';
    yrs.forEach(function (v) {
      var o = document.createElement('option'); o.value = v; o.textContent = v; selYear.appendChild(o);
    });
    selYear.disabled = !mo;
    selTrim.disabled = true;
    selTrim.innerHTML = '<option value="">Select year first</option>';
    render();
  }

  function updateTrims() {
    var m = selMake.value, mo = selModel.value, y = selYear.value;
    var trims = uniq(filtered(m, mo, y).map(function (p) { return p.trim; }).filter(function (t) { return t !== ''; }));
    selTrim.innerHTML = '<option value="">' + (y ? (trims.length ? 'All Variants' : 'No variants') : 'Select year first') + '</option>';
    trims.forEach(function (v) {
      var o = document.createElement('option'); o.value = v; o.textContent = v; selTrim.appendChild(o);
    });
    selTrim.disabled = !y || !trims.length;
    render();
  }

  selMake.addEventListener('change', updateModels);
  selModel.addEventListener('change', updateYears);
  selYear.addEventListener('change', updateTrims);
  selTrim.addEventListener('change', render);
  resetBtn.addEventListener('click', function () { selMake.value = ''; updateModels(); });

  // ── BUILD A SINGLE CARD ──
  function buildCard(p, i) {
    var card = document.createElement('div');
    card.className = 'ppf-pcard';
    card.style.animationDelay = (Math.min(i, 18) * 0.033) + 's';

    var imgHtml = p.image
      ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy" onerror="this.style.display=\'none\'">'
      : '<div class="ppf-cph"><svg width="44" height="44" viewBox="0 0 48 48" fill="none" stroke="white" stroke-width="1.5"><path d="M8 28l4-12h24l4 12" stroke-linecap="round"/><rect x="6" y="28" width="36" height="10" rx="3"/><circle cx="14" cy="38" r="3"/><circle cx="34" cy="38" r="3"/><path d="M14 22h20" stroke-linecap="round"/></svg><div class="ppf-cph-lbl">IMAGE<br>COMING SOON</div></div>';

    var yearDisplay = p.year || '';
    var cardTitle = p.displayModel;
    var cardSub = '';

    if (p.trim) {
      cardSub = p.trim + (p.chassis ? ' <span class="ppf-cchassis">(' + p.chassis + ')</span>' : '');
    } else if (p.chassis) {
      cardSub = '<span class="ppf-cchassis">(' + p.chassis + ')</span>';
    }
    if (!cardSub && p.fullModel && p.fullModel !== p.model) {
      var extra = p.fullModel.replace(p.model, '').trim();
      if (extra) cardSub = extra;
    }

    var cheapest = (PRICES.lite && PRICES.lite.partial) || 0;
    var priceHtml = TRADE_APPROVED
      ? 'from £' + cheapest.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : 'Sign in for pricing';

    card.innerHTML =
      '<div class="ppf-cimg">' + imgHtml + (yearDisplay ? '<div class="ppf-ypill">' + yearDisplay + '</div>' : '') + '</div>' +
      '<div class="ppf-cbody">' +
        '<div class="ppf-cmake">' + p.make + '</div>' +
        '<div class="ppf-ctitle">' + cardTitle + '</div>' +
        (cardSub ? '<div class="ppf-ctrim">' + cardSub + '</div>' : '') +
        '<div class="ppf-cfooter"><span class="ppf-cbase">' + priceHtml + '</span><span class="ppf-ccta">Build Kit →</span></div>' +
      '</div>';

    card.addEventListener('click', (function (prod) {
      return function () { openModal(prod); };
    })(p));

    return card;
  }

  // ── APPEND A BATCH OF CARDS ──
  function appendBatch(list, offset) {
    var batch = list.slice(offset, offset + BATCH_SIZE);
    var frag = document.createDocumentFragment();
    batch.forEach(function (p, i) {
      frag.appendChild(buildCard(p, offset + i));
    });
    pgrid.appendChild(frag);
    return offset + batch.length;
  }

  // ── UPDATE LOAD MORE BUTTON ──
  function updateLoadMore(list, offset, hasFilters) {
    var btn = document.getElementById('ppf-load-more');
    if (!btn) return;
    if (!hasFilters && offset < list.length) {
      btn.style.display = 'block';
      btn.onclick = function () {
        currentOffset = appendBatch(currentList, currentOffset);
        updateLoadMore(currentList, currentOffset, false);
      };
    } else {
      btn.style.display = 'none';
    }
  }

  // ── RENDER GRID ──
  function render() {
    var m = selMake.value, mo = selModel.value, y = selYear.value, t = selTrim.value;
    var has = m || mo || y || t;
    resetBtn.style.display = has ? 'inline-block' : 'none';

    var results = PRODUCTS.filter(function (p) {
      return (!m || p.make === m) && (!mo || p.model === mo) && (!y || p.year === y) && (!t || p.trim === t);
    });

    if (has && !results.length) {
      pgrid.style.display = 'none';
      nores.style.display = 'block';
      resCnt.style.display = 'none';
      var cfMake  = document.getElementById('ppf-cf-make');
      var cfModel = document.getElementById('ppf-cf-model');
      var cfYear  = document.getElementById('ppf-cf-year');
      if (cfMake  && m)  cfMake.value  = m;
      if (cfModel && mo) cfModel.value = mo;
      if (cfYear  && y)  cfYear.value  = y;
      updateLoadMore([], 0, true);
      return;
    }

    pgrid.style.display = 'grid';
    nores.style.display = 'none';
    resCnt.style.display = has ? 'inline' : 'none';
    if (has) resCnt.textContent = results.length + ' kit' + (results.length !== 1 ? 's' : '') + ' found';

    pgrid.innerHTML = '';
    currentList = has ? results : PRODUCTS;
    currentOffset = 0;

    currentOffset = appendBatch(currentList, 0);
    updateLoadMore(currentList, currentOffset, false);
  }

  // ── FILM SELECTOR ──
  window.ppfSelectFilm = function (card) {
    document.querySelectorAll('.ppf-fs-card').forEach(function (c) { c.classList.remove('active'); });
    card.classList.add('active');
    selBrandKey = card.dataset.brand;
    document.querySelectorAll('.ppf-brand-card').forEach(function (c) {
      c.classList.toggle('active', c.dataset.brand === selBrandKey);
    });
    updatePrice();
  };

  window.ppfSelectModalBrand = function (card) {
    document.querySelectorAll('.ppf-brand-card').forEach(function (c) { c.classList.remove('active'); });
    card.classList.add('active');
    selBrandKey = card.dataset.brand;
    document.querySelectorAll('.ppf-fs-card').forEach(function (c) {
      c.classList.toggle('active', c.dataset.brand === selBrandKey);
    });
    updatePrice();
  };

  function updatePrice() {
    var el = document.getElementById('ppf-m-price');
    if (!el) return;
    if (!TRADE_APPROVED) {
      el.innerHTML = '<span class="ppf-price-locked">Sign in for pricing</span>';
      return;
    }
    var incVat = calcPrice();
    var exVat = incVat / 1.2;
    el.innerHTML = '£' + exVat.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
      '<span class="ppf-price-incvat">£' + incVat.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' inc. VAT</span>';
  }

  function updateDiagram() {
    var img = document.getElementById('ppf-coverage-diagram-img');
    if (!img) return;
    var src = DIAGRAMS[selCovKey] || DIAGRAMS.custom || '';
    if (src) img.src = src;
  }

  // ── COVERAGE SELECTION ──
  document.querySelectorAll('.ppf-cov-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var cov = this.dataset.cov;
      if (cov === 'custom') {
        closeModal();
        setTimeout(function() {
          var cfSection = document.getElementById('ppf-cf-fields');
          if (!cfSection) return;
          cfSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var bsec = cfSection.closest('.ppf-bsec');
          if (bsec) {
            bsec.style.transition = 'box-shadow .4s';
            bsec.style.boxShadow = '0 0 0 3px rgba(26,26,26,.35)';
            setTimeout(function() { bsec.style.boxShadow = ''; }, 2000);
          }
        }, 350);
        return;
      }
      document.querySelectorAll('.ppf-cov-card').forEach(function (c) { c.classList.remove('active'); });
      this.classList.add('active');
      selCovKey = cov || 'front';
      updatePrice();
      updateDiagram();
    });
  });

  // ── DELIVERY DATE ──
  function isDST(d) {
    function lastSun(yr, mo) {
      var d = new Date(Date.UTC(yr, mo, 31));
      d.setUTCDate(31 - d.getUTCDay());
      return d;
    }
    var start = lastSun(d.getUTCFullYear(), 2);
    var end   = lastSun(d.getUTCFullYear(), 9);
    return d >= start && d < end;
  }

  function nextWorkingDay(d) {
    var next = new Date(d);
    next.setUTCDate(next.getUTCDate() + 1);
    while (next.getUTCDay() === 0 || next.getUTCDay() === 6) {
      next.setUTCDate(next.getUTCDate() + 1);
    }
    return next;
  }

  function getDeliveryInfo() {
    var now = new Date();
    var offset = isDST(now) ? 1 : 0;
    var ukH = (now.getUTCHours() + offset) % 24;
    var ukM = now.getUTCMinutes();
    var totalMins = ukH * 60 + ukM;
    var cutoff    = 13 * 60;
    var beforeCutoff = totalMins < cutoff;

    var dispatch = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    if (!beforeCutoff) dispatch.setUTCDate(dispatch.getUTCDate() + 1);
    while (dispatch.getUTCDay() === 0 || dispatch.getUTCDay() === 6) {
      dispatch.setUTCDate(dispatch.getUTCDate() + 1);
    }

    var delivery = nextWorkingDay(dispatch);

    var urgency = '';
    if (beforeCutoff) {
      var left = cutoff - totalMins;
      var h = Math.floor(left / 60), m = left % 60;
      urgency = h > 0 ? 'Order within ' + h + 'h ' + m + 'm' : 'Order within ' + m + 'm';
    }

    var days   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function fmt(d) { return days[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + months[d.getUTCMonth()]; }

    return { dispatch: fmt(dispatch), delivery: fmt(delivery), beforeCutoff: beforeCutoff, urgency: urgency };
  }

  function updateDelivery() {
    var info = getDeliveryInfo();
    var main = document.getElementById('ppf-delivery-main');
    var sub  = document.getElementById('ppf-delivery-sub');
    var urg  = document.getElementById('ppf-delivery-urgency');
    if (!main) return;
    main.innerHTML = 'Estimated delivery: <span>' + info.delivery + '</span>';
    sub.textContent = 'Dispatched ' + info.dispatch + ' via APC next-day courier';
    if (info.urgency) {
      urg.textContent = info.urgency;
      urg.style.display = 'block';
    } else if (!info.beforeCutoff) {
      urg.textContent = 'Order placed after 1pm cut-off';
      urg.style.display = 'block';
    } else {
      urg.style.display = 'none';
    }
  }

  // ── MODAL ──
  function openModal(p) {
    currentHandle = p.handle;
    document.getElementById('ppf-m-make').textContent  = p.make;
    document.getElementById('ppf-m-title').textContent = p.fullModel + (p.chassis ? ' (' + p.chassis + ')' : '');
    document.getElementById('ppf-m-year').textContent  = p.year;

    selCovKey = 'front';
    document.querySelectorAll('.ppf-cov-card').forEach(function (c) { c.classList.toggle('active', c.dataset.cov === 'front'); });
    document.querySelectorAll('.ppf-cust-check input').forEach(function (c) { c.checked = false; });

    var atcBtn = document.getElementById('ppf-m-atc');
    if (atcBtn) atcBtn.textContent = TRADE_APPROVED ? 'Order This Kit →' : 'Sign in to Order →';

    updatePrice();
    updateDiagram();
    updateDelivery();

    moverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    moverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.getElementById('ppf-mclose').addEventListener('click', closeModal);
  moverlay.addEventListener('click', function (e) { if (e.target === moverlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  // ── ORDER KIT ──
  document.getElementById('ppf-m-atc').addEventListener('click', function () { orderKit(); });

  async function orderKit() {
    if (!TRADE_APPROVED) {
      window.location.href = S.loginUrl || '/account/login';
      return;
    }

    var btn = document.getElementById('ppf-m-atc');
    var orig = btn.textContent;
    btn.textContent = 'Adding to cart...';
    btn.disabled = true;

    var covValue   = COVERAGE_MAP[selCovKey]   || 'Front End';
    var brandValue = BRAND_MAP[selBrandKey]     || 'STEK DynoSheild -Gloss';

    try {
      var res = await fetch('/products/' + currentHandle + '.js');
      if (!res.ok) throw new Error('not found');
      var product = await res.json();

      var variant = product.variants.find(function (v) {
        return v.option1 === covValue && v.option2 === brandValue;
      }) || product.variants.find(function (v) {
        return v.option1 === covValue;
      }) || product.variants.find(function (v) {
        return v.available;
      }) || product.variants[0];

      if (!variant) throw new Error('no variant');

      var cartRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });

      if (!cartRes.ok) throw new Error('cart error');
      window.location.href = '/checkout';

    } catch (err) {
      console.warn('PPF checkout error:', err);
      var params = new URLSearchParams({ option1: covValue, option2: brandValue });
      window.location.href = '/products/' + currentHandle + '?' + params.toString();
    } finally {
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  // ── INIT ──
  render();

  // Arriving from a homepage teaser card (?kit=<handle>) — open that kit directly
  // instead of dropping the visitor on the general grid to re-search for it.
  var kitParam = new URLSearchParams(window.location.search).get('kit');
  if (kitParam) {
    var deepLinkTarget = PRODUCTS.find(function (p) { return p.handle === kitParam; });
    if (deepLinkTarget) {
      setTimeout(function () { openModal(deepLinkTarget); }, 50);
    }
  }
}

window.ppfInit = ppfInit;
if (window.PPF_PRODUCTS && window.PPF_PRODUCTS.length) ppfInit();
